module.exports = __webpack_public_path__ + "img/156.a22a4713.jpg";